import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { CalendarSurfaceStore } from 'owa-calendar-surface-dategrid';
import { action } from 'satcheljs/lib/legacy';

/**
 * Called to update the currently selected item on surface.
 * @newValue The newly selected item
 * @selectedItemCSSSelector The current selected items' cssselector
 * @store The surface store
 * @customSelector - If we have to select an item that does not follow the regular norm of CSSSelector,
 * one can pass a custom selector. For instance, agenda peek uses this to select calendar items on it.
 */
export let updateSelectedItem = action('updateSelectedItems')(function updateSelectedItems(
    newValue: CalendarEvent,
    selectedItemCSSSelector: string,
    store: CalendarSurfaceStore,
    customSelector: string = null
) {
    // remove the lock on selectedItem if we are updating the selectedItem to a different non-null value
    if (newValue && store.selectedItem != newValue) {
        store.lockSelectedItem = false;
    }

    // if newValue is null (case of clearing the selectedItem) and the currently selected item is locked, then do not proceed
    if (!newValue && store.lockSelectedItem) {
        return;
    }

    if (!customSelector && store.selectedItem != newValue) {
        store.selectedItem = newValue;
    }
    store.selectedItemCSSSelector = selectedItemCSSSelector;
});
